import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16" data-id="element-158">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-159">
        <FadeIn data-id="element-160">
          <div className="bg-gradient-to-br from-brand-card to-brand-darker border-2 border-slate-700 p-8 md:p-12 rounded-3xl text-center relative overflow-hidden" data-id="element-161">
            {/* Background glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-brand-accent/5 blur-3xl rounded-full pointer-events-none" data-id="element-162" />

            <ShieldCheck className="w-16 h-16 text-brand-accent mx-auto mb-6 relative z-10" data-id="element-163" />

            <h2 className="text-3xl font-bold text-white mb-6 relative z-10" data-id="element-164">
              🛡️ GARANTÍA 45 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="space-y-4 text-lg text-slate-300 relative z-10" data-id="element-165">
              <p data-id="element-166">Abrís los tomos. Usás los prompts.</p>
              <p data-id="element-167">Aplicás las macros en tu estudio real.</p>
              <p className="font-bold text-white mt-6" data-id="element-168">
                Si en 45 días no es exactamente lo que esperabas:
                <br data-id="element-169" />
                <span className="text-brand-accent" data-id="element-170">
                  devolución del 100% del dinero.
                </span>
              </p>
              <p className="mt-6" data-id="element-171">Sin formularios. Sin drama. Sin preguntas.</p>
              <p className="text-sm text-slate-500 mt-8" data-id="element-172">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}